module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_sans-medium-web.eot?60f45ab3bc801187da8062827f59550e";